import type { PlanLimits } from "@rivaled/shared";

export function limitsToFeatureList(limits: PlanLimits): string[] {
  const features: string[] = [];

  if (limits.maxQueues === 0) {
    features.push("Unlimited queues");
  } else {
    features.push(`Up to ${limits.maxQueues} queues`);
  }

  if (limits.maxMembers === 0) {
    features.push("Unlimited members");
  } else {
    features.push(`Up to ${limits.maxMembers.toLocaleString()} members`);
  }

  if (limits.hasVisualEditor) features.push("Visual match editor");
  if (limits.hasAdvancedSettings) features.push("Advanced queue/match settings");
  if (limits.hasSeasons) features.push("Season management");
  if (limits.hasBrandingRemoval) features.push("Branding removal");
  if (limits.hasPrioritySupport) features.push("Priority support");
  if (limits.hasDedicatedSupport) features.push("Dedicated support");
  if (limits.hasApiAccess) features.push("API access & webhooks");

  return features;
}

export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;
}
